import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ChatPage from './pages/ChatPage';
import Sidebar from './components/landing/Sidebar';
import { ChatProvider } from './context/ChatContext';
// AuthProvider removed
import { getDeraStatus } from './utils/api';
import { cx } from './styles';

// Removed authentication wrapper
// Wrapper component to conditionally render sidebar based on route
const AppContent = () => {
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [deraStatus, setDeraStatus] = useState({ 
    initialized: false, 
    status: 'inactive' as 'active' | 'inactive'
  });
  // Auth removed - all users have access
  
  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // 768px is typical md breakpoint
    };
    
    // Initial check
    checkMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Close sidebar when changing routes on mobile
  useEffect(() => {
    if (isMobile) {
      setShowSidebar(false);
    }
  }, [location.pathname, isMobile]);

  // Check DERA status when app initializes
  useEffect(() => {
    const checkDeraStatus = async () => {
      try {
        const status = await getDeraStatus();
        setDeraStatus(status);
      } catch (error) {
        console.error('Error checking DERA status:', error);
        setDeraStatus({ 
          initialized: false, 
          status: 'inactive' 
        });
      }
    };

    checkDeraStatus();
    // Set up interval to check status periodically
    const intervalId = setInterval(checkDeraStatus, 60000); // Check every minute
    
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className={cx("App min-h-screen flex", "bg-page")}>
      {/* Sidebar - always visible on desktop, toggle on mobile */}
      <Sidebar 
        isOpen={isMobile ? showSidebar : true} 
        onClose={() => setShowSidebar(false)} 
        isMobile={isMobile}
      />
      
      {/* Main content area */}
      <div className={`flex-1 ${isMobile ? 'w-full' : ''}`}>
        <Routes>
          <Route path="/" element={<LandingPage deraStatus={deraStatus} />} />
          <Route 
            path="/chat" 
            element={<ChatPage 
              onToggleSidebar={() => setShowSidebar(!showSidebar)}
              isMobile={isMobile}
            />} 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
};

function App() {
  return (
    <ChatProvider>
      <Router>
        <AppContent />
      </Router>
    </ChatProvider>
  );
}

export default App;
